import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const Battery60FilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M5.64 6.22v.9h3.6v-1.8h-3.6v.9m9.12 0v.9h3.6v-1.8h-3.6v.9M5.492 8.297a2.785 2.785 0 0 0-.56.202c-.415.203-.892.676-1.085 1.077-.244.503-.246.533-.246 3.464 0 2.93.003 2.96.245 3.464.185.384.706.905 1.09 1.09.533.257.189.245 7.064.245s6.531.012 7.064-.245c.384-.185.905-.706 1.09-1.09.242-.504.245-.534.245-3.464 0-2.931-.002-2.961-.246-3.464-.202-.42-.671-.877-1.113-1.087a2.81 2.81 0 0 0-.603-.205c-.395-.066-12.608-.054-12.945.013m12.797 1.833a.638.638 0 0 1 .235.238c.072.142.076.273.075 2.68v2.532l-.09.156a.696.696 0 0 1-.228.23c-.134.071-.378.074-6.281.074s-6.147-.003-6.281-.074a.696.696 0 0 1-.228-.23l-.09-.156v-2.532c-.001-2.458.001-2.536.079-2.689a.597.597 0 0 1 .23-.237c.147-.077.256-.078 6.285-.08l6.134-.002.16.09M6.717 11.357l-.117.117v3.132l.117.117.117.117h6.246v-3.6H6.834l-.117.117"
      />
    </SvgIcon>
  );
});
